<template>
	<div id="app">
		<bohemia-header
			:user-data="user"
			id="navbar"
			:authBaseUrl="'/api/v1.0/'"
		></bohemia-header>
		<transition name="fade" mode="out-in">
			<router-view />
		</transition>
		<Notifications />
		<bi-footer class="bi-footer"></bi-footer>
	</div>
</template>

<script>
//import BiNavbar from '@bistudio/bohemia-vue-components/dist/BiNavbar';
//import '@bistudio/bohemia-vue-components/dist/BiNavbar/BiNavbar.css';
import BohemiaHeader from "@bistudio/bohemia-vue-components-old/src/components/header/Header";
// import BiFooter from "@bistudio/bohemia-vue-components/dist/BiFooter";
import BiFooter from "./components/coppiedFooter/Footer";
import "@bistudio/bohemia-vue-components/dist/BiFooter/BiFooter.css";
import Notifications from "./components/common/Notifications";
import {
	INTERNSHIPS_PAGE_NAME,
	JOIN_PAGE_NAME,
	OPEN_APPLICATION_PAGE_NAME,
	POSITIONS_PAGE_NAME,
	EXPATS_PAGE_NAME
} from "./router/pageConstants";
import { mapActions, mapGetters } from "vuex";

export default {
	name: "App",
	created() {
		this.loadUser();
	},
	data() {
		return {
			navLinks: [
				{ url: { name: JOIN_PAGE_NAME }, name: "start" },
				{ url: { name: POSITIONS_PAGE_NAME }, name: "Job openings" },
				{
					url: { name: OPEN_APPLICATION_PAGE_NAME },
					name: "Open application"
				},
				{ url: { name: INTERNSHIPS_PAGE_NAME }, name: "Internships" },
				{ url: { name: EXPATS_PAGE_NAME }, name: "Expats" }
			]
		};
	},
	computed: {
		...mapGetters("user", {
			user: "user"
		}),
		...mapGetters("navigation", {
			stateUpdated: "stateUpdated"
		})
	},
	methods: {
		...mapActions("user", ["loadUser"])
	},
	metaInfo: {
		title: "Careers - Start new game",
		titleTemplate: "%s | Bohemia Interactive"
	},
	components: {
		BiFooter,
		Notifications,
		BohemiaHeader
	},
	watch: {
		stateUpdated() {
			this.$refs.bohemiaHeader.closeNav();
		}
	}
};
</script>

<style lang="scss" type="text/scss">
@import "assets/scss/slick";

#app {
	position: relative;
}
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.bi-footer {
	position: relative;
	z-index: 12;
}
</style>



// WEBPACK FOOTER //
// src/App.vue